import { Input } from "antd"
import type { OTPProps } from "antd/es/input/OTP"
import React from "react"

const digitsOnly = (value: string) => value.replace(/\D/g, "")

/** A one-time code typed digit by digit; never auto-capitalized, digits only. */
export function CodeInput(props: Omit<OTPProps, "formatter">) {
  return <Input.OTP formatter={digitsOnly} {...props} />
}
